var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdealPay = function SvgIdealPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idealPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 3.994v12.011c0 .575.47 1.046 1.045 1.046h7.177c5.426 0 7.778-3.037 7.778-7.067 0-4.01-2.352-7.036-7.778-7.036H9.045C8.47 2.948 8 3.418 8 3.994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C06",
    d: "M12.803 5.896v8.876h3.863c3.507 0 5.028-1.981 5.028-4.783 0-2.682-1.521-4.762-5.028-4.762h-3.194a.67.67 0 0 0-.67.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.223 16.094h-6.24c-.555 0-1.004-.45-1.004-1.003V4.914c0-.554.449-1.004 1.003-1.004h6.241c5.922 0 6.806 3.81 6.806 6.08 0 3.935-2.42 6.104-6.806 6.104m-6.24-11.85a.667.667 0 0 0-.67.67V15.09c0 .37.298.669.67.669h6.24c4.171 0 6.471-2.05 6.471-5.77 0-4.998-4.056-5.745-6.47-5.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.164 8.792q.202 0 .382.063c.12.042.22.11.308.193q.126.136.204.325.072.194.073.46 0 .233-.057.428-.062.197-.178.34a.9.9 0 0 1-.298.225c-.12.052-.262.083-.424.083h-.914V8.787h.904zm-.031 1.73c.068 0 .13-.01.198-.03a.4.4 0 0 0 .168-.11.6.6 0 0 0 .12-.2.8.8 0 0 0 .047-.297c0-.105-.01-.204-.032-.288a.6.6 0 0 0-.104-.22.5.5 0 0 0-.188-.14.8.8 0 0 0-.288-.047h-.334v1.338h.413zM17.017 8.792v.392H15.9v.455h1.03V10h-1.03v.518h1.145v.392h-1.61V8.787h1.583zM18.614 8.792l.794 2.122h-.486l-.162-.47h-.794l-.167.47h-.47l.799-2.122zm.026 1.302-.267-.78h-.005l-.277.78zM20.168 8.792v1.73h1.035v.392h-1.5V8.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.056 10.83a.977.977 0 1 0 0-1.954.977.977 0 0 0 0 1.955M11.796 14.772c-.821 0-1.48-.664-1.48-1.48v-1.155a.742.742 0 1 1 1.485 0v2.635z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "idealPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgIdealPay;